import { render } from "./Folder.vue?vue&type=template&id=e9fdae46"
import script from "./Folder.vue?vue&type=script&lang=js"
export * from "./Folder.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__